import boxShadows from "assets/theme/box-shadow.js";
import themeColors from "assets/theme/colors";
import hexToRgb from "assets/theme/hex-to-rgb.js";

const componentStyles = (theme) => ({
  cardRoot: {
    boxShadow: boxShadows.boxShadow + "!important",
  },
  cardRootTranslucent: {
    backgroundColor: themeColors.transparent.main,
  },
  cardRootStripped: {
    "& tbody tr:nth-child(odd)": {
      backgroundColor: "rgba(" + hexToRgb(themeColors.gray[100]) + ", 0.3)",
    },
  },
  cardRootCheckboxColors: {
    "& tbody tr:nth-child(1)": {
      backgroundColor: themeColors.success.tableLight,
      "&:hover": {
        backgroundColor: themeColors.success.tableLightHover,
      },
    },
    "& tbody tr:nth-child(3)": {
      backgroundColor: themeColors.warning.tableLight,
      "&:hover": {
        backgroundColor: themeColors.warning.tableLightHover,
      },
    },
  },
  cardRootDark: {
    backgroundColor: themeColors.dark.main,
    "& *": {
      color: themeColors.white.main,
    },
    "& $tableCellRoot, & $tableRoot": {
      color: themeColors.white.main,
      borderColor: themeColors.dark.tableBorder,
    },
    "& $tableCellRootHead": {
      color: themeColors.dark.tableHeadColor,
      backgroundColor: themeColors.dark.tableHeadBgColor,
    },
  },
  cardHeader: {
    backgroundColor: "initial",
  },
  cardActionsRoot: {
    paddingBottom: "1.5rem!important",
    paddingTop: "1.5rem!important",
    borderTop: "0!important",
  },
  tableRoot: {
    marginBottom: "0!important",
  },
  tableCellRoot: {
    verticalAlign: "middle",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    borderTop: "0",
  },
  tableCellRootHead: {
    backgroundColor: themeColors.gray[100],
    color: themeColors.gray[600],
  },
  tableCellRootBodyHead: {
    textTransform: "unset!important",
    fontSize: ".8125rem",
  },
  linearProgressRoot: {
    height: "3px!important",
    width: "120px!important",
    margin: "0!important",
  },
  bgGradientError: {
    background:
      "linear-gradient(87deg," +
      themeColors.error.main +
      ",#f56036)!important",
  },
  bgGradientSuccess: {
    background:
      "linear-gradient(87deg," +
      themeColors.success.main +
      ",#2dcecc)!important",
  },
  bgGradientPrimary: {
    background:
      "linear-gradient(87deg," +
      themeColors.primary.main +
      ",#825ee4)!important",
  },
  bgGradientInfo: {
    background:
      "linear-gradient(87deg," +
      themeColors.info.main +
      ",#DF767D)!important",
  },
  bgGradientWarning: {
    background:
      "linear-gradient(87deg," +
      themeColors.warning.main +
      ",#fbb140)!important",
  },
  bgPrimary: {
    backgroundColor: themeColors.primary.main,
  },
  bgPrimaryLight: {
    backgroundColor: themeColors.primary.light,
  },
  bgError: {
    backgroundColor: themeColors.error.main,
  },
  bgErrorLight: {
    backgroundColor: themeColors.error.light,
  },
  bgWarning: {
    backgroundColor: themeColors.warning.main,
  },
  bgWarningLight: {
    backgroundColor: themeColors.warning.light,
  },
  bgInfo: {
    backgroundColor: themeColors.info.main,
  },
  bgInfoLight: {
    backgroundColor: themeColors.info.light,
  },
  bgSuccess: {
    backgroundColor: themeColors.success.main,
  },
  verticalAlignMiddle: {
    verticalAlign: "middle",
  },
  avatarRoot: {
    width: "36px",
    height: "36px",
    fontSize: ".875rem",
  },
  anchorStyles: {
    fontWeight: "600",
  },
  buttonRootWhite: {
    color: themeColors.primary.main,
    backgroundColor: themeColors.white.main,
    borderColor: themeColors.white.main,
    "&:hover": {
      backgroundColor: themeColors.white.main,
      borderColor: themeColors.white.main,
      color: themeColors.dark.main,
    },
  },
});

export default componentStyles;
